
if(!__webpack_require__.federation){
    __webpack_require__.federation = {
        
chunkMatcher: function(chunkId) {
    return !/^(6(061|093|510)|(130|760|878)9|3754|497|5470|8353)$/.test(chunkId);
},
rootOutputDir: "../../",

    };
}
